import {
  PostAdminCMSRoleInterface,
  DeleteAdminCMSRoleInterface,
  UpdateAdminCMSRoleInterface,
} from '@/data/payload/contracts/AdminCMSRoleRequest'

export class AdminCMSRoleApiRequest implements PostAdminCMSRoleInterface {
  private roleName: string
  private needSalesCode: boolean
  private menu: []

  constructor(roleName: string, needSalesCode: boolean, menu: []) {
    this.roleName = roleName
    this.needSalesCode = needSalesCode
    this.menu = menu
  }

  public toJSON() {
    const data = {
      role_name: this.roleName,
      need_sales_code: this.needSalesCode,
      menu: this.menu,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class DeleteAdminCMSRoleApiRequest
  implements DeleteAdminCMSRoleInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class UpdateAdminCMSRoleApiRequest
  implements UpdateAdminCMSRoleInterface {
  private id: number
  private roleName: string
  private menu: []

  constructor(id: number, roleName: string, menu: []) {
    this.id = id
    this.roleName = roleName
    this.menu = menu
  }

  public toJSON() {
    const data = {
      id: this.id,
      role_name: this.roleName,
      menu: this.menu,
    }

    return JSON.stringify({
      data,
    })
  }
}
